import { ref as k, onMounted as p, onUnmounted as K, unref as m } from "vue";
const Y = (l) => {
  const { isDropdownOpen: o, disableSpaceHandler: _ } = l, n = k(-1), t = k(-1), u = (e) => {
    const r = "ArrowUp", c = "ArrowDown", E = "Enter", d = "Escape", s = " ", v = "PageUp", i = "Home", y = "PageDown", f = "End";
    if (!o.value || ![
      r,
      c,
      E,
      d,
      s,
      v,
      i,
      y,
      f
    ].includes(e.key))
      return;
    const a = m(l.optionsLength);
    if (e.key === r)
      n.value = n.value === 0 ? a - 1 : n.value - 1;
    else if (e.key === c)
      n.value = (n.value + 1) % a;
    else if (e.key === E || e.key === s) {
      if (e.key === s && _)
        return;
      t.value = n.value, o.value = !1;
    } else
      e.key === d ? (n.value = t.value, o.value = !1) : e.key === v || e.key === i ? n.value = 0 : (e.key === y || e.key === f) && (n.value = a - 1);
    e.stopPropagation(), e.preventDefault();
  };
  return p(() => {
    document && document.addEventListener("keydown", u);
  }), K(() => {
    document && document.removeEventListener("keydown", u);
  }), {
    activeIdx: n,
    selectedIdx: t
  };
};
export {
  Y as useKeyboardController
};
